import React from 'react';
import Container from "./Container";
import AssetGroup from "./AssetGroup";

const Category = ({ category, selectedAsset, hoveredAsset, onSelectAsset, onHoverAsset }) => (
  <Container
    className='category'
    icon={category.icon}
    title={category.name}
  >
    {
      category.groups.map(
        group => (
          <AssetGroup
            key={group.id}
            group={group}
            selectedAsset={selectedAsset}
            hoveredAsset={hoveredAsset}
            onSelectAsset={onSelectAsset}
            onHoverAsset={onHoverAsset}
            containsGroups={group.assetGroups && group.assetGroups.length > 0}
          />
        )
      )
    }
  </Container>
);

export default Category;
